'use client'

import { useState } from 'react'

export default function DateRangePicker({ onChange }: { onChange: (start: string, end: string) => void }) {
  const [start, setStart] = useState('')
  const [end, setEnd] = useState('')

  const handleApply = () => {
    if (start && end) {
      onChange(start, end)
    }
  }

  return (
    <>
      <div className="flex justify-between items-center">
        <div className="w-full flex gap-2 items-center">
          <input
            type="date"
            value={start}
            onChange={(e) => setStart(e.target.value)}
            className="w-full flex-1 border rounded px-2 py-2"
          />
          <span>até</span>
          <input
            type="date"
            value={end}
            onChange={(e) => setEnd(e.target.value)}
            className="w-full flex-1 border rounded px-2 py-2"
          />
        </div>
      </div>
      <button onClick={handleApply} className="w-full mt-2 py-4 bg-blue-600 hover:bg-blue-800 text-white text-center rounded-xl transition">
          Aplicar
      </button>
    </>
  )
}
